<div class="services-apps">
  <app-back-button [title]="'module.serviceApps.titleName' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
  <div class="service-apps-header-container"></div>

  <ng-container *ngIf="maintenanceStatus$ | async as maintenanceStatus">
    <app-notification-card *ngIf="maintenanceStatus.hasActiveMaintenance && maintenanceStatus.type === maintenanceTypes.UNPLANNED" type="outage" header="{{ 'module.shared.maintenanceNotification.unplannedEvent.header' | translate }}" [description]="maintenanceStatus.message"></app-notification-card>
  </ng-container>

  <mat-tab-group [animationDuration]="0" [disableRipple]="true">
    <mat-tab>
      <ng-template mat-tab-label>
        <div>
          <span class="tab-text">Lieferantenwechsel</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content">
          <div>
            <div class="change-supplier">
              <app-info-box [information]="'module.serviceApps.lieferantenwechselInfo' | translate" (downloadEvent)="downloadExcel(false)"></app-info-box>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <div>
          <span class="tab-text">Kommunalrabatt</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content">
          <div>
            <div class="municipal-discount">
              <app-info-box [information]="'module.serviceApps.kommunalrabattInfo' | translate" (downloadEvent)="downloadExcel(true)"></app-info-box>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
